import type { T } from '../i18n';
import { set } from '../state';
import type { AppState } from '../state';
import { StampArt } from '../stamp';
import { FLAGS, denomination } from '../util';

const TILTS = [-4.5, 2.4, -1.6, 3.4, -2.8, 1.2, -3.6, 2, -1.1, 3, -2.2, 1.8];
const TAPES = [7, -5, 4, -8, 6, -3, 5, -6, 3, -7, 4, -4];

/** Every stamp that has arrived on a card, taped into the album newest first. */
export function Album({ s, t }: { s: AppState; t: T }) {
  return (
    <div class="panel">
      <div class="title">{t('stampsTitle')}</div>
      <div class="subtitle">{t('collected', { n: s.album.length })}</div>
      {s.album.length === 0 ? (
        <div class="empty" style={{ marginTop: '20px' }}>
          {t('albumEmpty')}
        </div>
      ) : (
        <div class="album-page">
          <div class="album-grid">
            {s.album.map((stamp, i) => (
              <button
                key={stamp.id}
                class="album-cell"
                aria-label={stamp.label}
                style={`--tilt: rotate(${TILTS[i % TILTS.length]}deg); --tape: rotate(${TAPES[i % TAPES.length]}deg)`}
                onClick={() => set({ zoomIndex: i })}
              >
                <span class="album-tape" />
                <StampArt stamp={stamp} />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export function Zoom({ s, t }: { s: AppState; t: T }) {
  const stamp = s.zoomIndex === null ? undefined : s.album[s.zoomIndex];
  if (!stamp) return null;

  const series = s.series.find((x) => x.key === stamp.series)?.pretty ?? '';
  const flag = FLAGS[stamp.country];

  return (
    <div class="scrim zoom" role="dialog" aria-modal="true" aria-label={stamp.label} onClick={() => set({ zoomIndex: null })}>
      <div class="zoom-stamp">
        <StampArt stamp={stamp} />
      </div>
      <div class="zoom-info">
        <div class="zoom-country">
          {flag && <span class="flag" style={{ background: flag }} />}
          <span>{stamp.country}</span>
        </div>
        <div class="zoom-title">{stamp.label}</div>
        <div class="zoom-series">{t('seriesLine', { series, value: denomination(stamp.country, stamp.denom) })}</div>
        <div class="zoom-from">{t('receivedFrom', { who: stamp.gifter })}</div>
        <div class="zoom-hint">{t('closeHint')}</div>
      </div>
    </div>
  );
}
